/**
 * i18n.js
 *
 * Browser/ESM version (Vite).
 *
 * For Node/CommonJS scripts, use `src/i18n.cjs`.
 */

import en_translation_messages from './translations/en.json'
import es_translation_messages from './translations/es.json'

import { DEFAULT_LOCALE, appLocales } from './locales.js'

// Optional polyfills (loaded only if needed).
/* istanbul ignore next */
if (!Intl.PluralRules) {
	import('@formatjs/intl-pluralrules/polyfill')
	import('@formatjs/intl-pluralrules/locale-data/en')
}
/* istanbul ignore next */
if (!Intl.RelativeTimeFormat) {
	import('@formatjs/intl-relativetimeformat/polyfill')
	import('@formatjs/intl-relativetimeformat/locale-data/en')
}

const formatTranslationMessages = (locale, messages) => {
	const default_formatted_messages =
		locale !== DEFAULT_LOCALE ? formatTranslationMessages(DEFAULT_LOCALE, en_translation_messages) : {}

	const flatten_formatted_messages = (formatted_messages, key) => {
		const formatted_message =
			!messages[key] && locale !== DEFAULT_LOCALE ? default_formatted_messages[key] : messages[key]
		return Object.assign(formatted_messages, { [key]: formatted_message })
	}

	return Object.keys(messages).reduce(flatten_formatted_messages, {})
}

const translationMessages = {
	en: formatTranslationMessages('en', en_translation_messages),
	es: formatTranslationMessages('es', es_translation_messages),
}

export { appLocales, formatTranslationMessages, translationMessages, DEFAULT_LOCALE }

export default {
	appLocales,
	formatTranslationMessages,
	translationMessages,
	DEFAULT_LOCALE,
}
